<template>
  <div>
    <ez-modal class="holamundo" title :active.sync="popupError">
      <div class="vx-row m-0">
        <div class="vx-col w-full text-center">
          <feather-icon
            icon="XOctagonIcon"
            class="p-6 my-8 bg-danger inline-flex rounded-full text-white shadow"
            svgClasses="h-8 w-8"
          ></feather-icon>
        </div>
        <div class="vx-col p-5 w-full text-center text-5xl font-semibold text-danger">
          PERHATIAN !
        </div>
        <div class="vx-col p-5 w-full text-center text-3xl font-semibold text-danger">
          Telah terjadi indikasi <strong>KORUPSI</strong> di lingkungan MPP Lombok Tengah !
        </div>
      </div>
    </ez-modal>
  </div>
</template>

<script>
import alertSound from "@/assets/sound/alert.mp3";

export default {
  name: "track-information-alert",
  data: () => ({
    popupError: false,
    registrationCode: null
  }),
  mounted(){
    this.listenTrackAlert();
  },
  methods: {
    listenTrackAlert(){
      var self = this;
      self.$echo.private(`User.TrackAlert.${self.$store.state.AppActiveUser.role}`)
      .listen(".OnAlertTrackEvent", () => {
        self.playAudio();
        self.popupError = true;
        window.setTimeout(function() {
          self.$router.push({ name: "track" });
        }, 5000);
      });
    },
    playAudio(){
      let audio = new Audio(alertSound);
      audio.play();
    }
  }
};
</script>